import { PublicLayout } from '#components/layouts/public.jsx'

export default function DocumentationLayout({ children }) {
  return <PublicLayout editorial>{children}</PublicLayout>
}
